import { Tooltip } from "@mui/material";
import Translate from "../../utils/Translate";
import { formatDate } from "../../utils/dateTimeFormat";
import { accessKeys, hasAccess } from "../../utils/userAccess";
import { Badge } from "@mui/icons-material";
import { digitalLicenseStatus } from "../../utils/actorLicense";

export default function StudentLicenseIconbox({ actorLicense }) {
  const addBr = actorLicense.digitalLicenseMessageBounce;
  const showStatusNotPublished =
    actorLicense.digitalLicenseId && actorLicense.digitalLicenseStatus != digitalLicenseStatus.published;
  return (
    <Tooltip
      className="iconbox"
      title={
        <div>
          <div>{`${Translate.get("LicenseDate")}: ${formatDate(actorLicense.validFrom)}${
            actorLicense.validTo ? ` - ${formatDate(actorLicense.validTo)}` : ""
          }`}</div>
          <div>{`${Translate.get("LastPrintDate")}: ${
            actorLicense.lastPrintDate ? formatDate(actorLicense.lastPrintDate) : "-"
          }`}</div>
          {hasAccess(accessKeys.digitalLicenses) && (
            <>
              {addBr && <br />}
              <div>{`${Translate.get("DigitalLicenseLabel")}: ${
                actorLicense.digitalLicenseId ? Translate.get("Yes") : Translate.get("No")
              }`}</div>
              {actorLicense.digitalLicenseMessageBounce && (
                <div>{`${Translate.get("Error")}: ${Translate.get("EmailBounce")}`}</div>
              )}
              {showStatusNotPublished && (
                <div>
                  <br />
                  <div>{`${Translate.get("DigitalLicenseLabel")} ${Translate.get("Status").toLowerCase()}`}:</div>
                  <div>{Translate.get("DigitalLicenseStatusIsNotPublished")}</div>
                </div>
              )}
            </>
          )}
        </div>
      }
      arrow
    >
      <Badge color={actorLicense.digitalLicenseMessageBounce ? "error" : ""} />
    </Tooltip>
    // <div>{Translate.get("Status")}<div>
    //             <br />
    //             <div>{Translate.get("DigitalLicenseStatusIsNotPublished")}</div>
  );
}
